import script from "./AssessmentOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentOverview.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentOverview.vue?vue&type=style&index=0&id=f7287798&lang=css"

const __exports__ = script;

export default __exports__